export default "__VITE_ASSET__9c1309fe__"